// @TODO Remove this when adding another export
/* eslint-disable import/prefer-default-export */

export const APPOINTMENT_DURATION = {
  clinic: {
    first: 45,
    follow: 25,
  },
  virtual: {
    first: 30,
    follow: 20,
  },
};
